import { generateUniqueId } from '../../helpers/common';

export const SELECT_VIEW_PERIOD = generateUniqueId();
export const SELECT_DAY = generateUniqueId();
export const SELECT_MONTH = generateUniqueId();
export const SELECT_YEAR = generateUniqueId();
export const SELECT_AGG = generateUniqueId();
export const SELECT_FIELDS = generateUniqueId();
export const RESET_SELECT_FIELDS = generateUniqueId();
export const SELECT_FIELDS_INDEX = generateUniqueId();

export const TOGGLE_STATION_FIELD = generateUniqueId();
export const SELECT_STATION = generateUniqueId();
export const TOGGLE_FIELD = generateUniqueId();

export const GET_FIND_STATIONS_FIELDS_REQUEST = generateUniqueId();
export const GET_FIND_STATIONS_FIELDS_SUCCESS = generateUniqueId();
export const GET_FIND_STATIONS_FIELDS_FAILURE = generateUniqueId();

export const GET_QUERY_HISTORY_REQUEST = generateUniqueId();
export const GET_QUERY_HISTORY_SUCCESS = generateUniqueId();
export const GET_QUERY_HISTORY_FAILURE = generateUniqueId();

export const FETCH_YEAR_INDICES_REQUEST = generateUniqueId();
export const FETCH_YEAR_INDICES_SUCCESS = generateUniqueId();
export const FETCH_YEAR_INDICES_FAILURE = generateUniqueId();

export const FETCH_DAY_DATA_REQUEST = generateUniqueId();
export const FETCH_DAY_DATA_FAILURE = generateUniqueId();
export const FETCH_DAY_DATA_SUCCESS = generateUniqueId();

export const FETCH_MONTH_DATA_REQUEST = generateUniqueId();
export const FETCH_MONTH_DATA_FAILURE = generateUniqueId();
export const FETCH_MONTH_DATA_SUCCESS = generateUniqueId();

export const FETCH_YEAR_DATA_REQUEST = generateUniqueId();
export const FETCH_YEAR_DATA_FAILURE = generateUniqueId();
export const FETCH_YEAR_DATA_SUCCESS = generateUniqueId();

export const FETCH_GRAPH_REF_REQUEST = generateUniqueId();
export const FETCH_GRAPH_REF_FAILURE = generateUniqueId();
export const FETCH_GRAPH_REF_SUCCESS = generateUniqueId();

export const SET_STATION_TIME_OFFSET = generateUniqueId();